module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-12-f54a3a4e52745d90a435eb727a33f3ff.jpg";